module.exports = __webpack_public_path__ + "static/banner-a4a538e359ce2a863aaf65cb6b8d3a0d.png";